import * as React from "react";
import { CustomFilterRenderProps } from "Components/ScrollableTable/components/ScrollableTableHeader";
import { Input, Row, Button } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

interface ViewSearchInputFilterProps extends CustomFilterRenderProps {}
export const ViewSearchInputFilter = (props: ViewSearchInputFilterProps) => {
  const { t } = useTranslation(I18N_NS.GENERAL);
  const [value, setValue] = React.useState<string>(props.selectedFilters?.[0] as string);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setValue(value);
    props.setFilters(value ? [value] : []);
  };

  const handleReset = () => {
    props.clearFilters();
    setValue("");
  };

  return (
    <div>
      <div className="mb-sm">
        <Input
          size="small"
          value={value}
          onChange={handleChange}
          onPressEnter={props.confirm}
          placeholder={t("Search")}
        />
      </div>
      <Row justify="space-between">
        <Button size="small" onClick={handleReset}>
          {t("Reset")}
        </Button>
        <Button size="small" type="primary" onClick={props.confirm}>
          OK
        </Button>
      </Row>
    </div>
  );
};
